const thesis = {
  path: 'thesis',
  component: resolve => require(['../../../../components/pages/studentUnion/thesis'], resolve)
}

const thesisSyllabus = {
  path: 'thesis/syllabus',
  component: resolve => require(['../../../../components/pages/studentUnion/thesis/Syllabus'], resolve)
}

const thesisDraft = {
  path: 'thesis/draft',
  component: resolve => require(['../../../../components/pages/studentUnion/thesis/Draft'], resolve)
}

const thesisFinal = {
  path: 'thesis/final',
  component: resolve => require(['../../../../components/pages/studentUnion/thesis/Final'], resolve)
}

const thesisDocument = {
  path: 'thesis/document',
  component: resolve => require(['../../../../components/pages/studentUnion/thesis/Document'], resolve)
}

const thesisScore = {
  path: 'thesis/score',
  component: resolve => require(['../../../../components/pages/studentUnion/thesis/Score'], resolve)
}

export default [thesis, thesisSyllabus, thesisDraft, thesisFinal, thesisDocument, thesisScore]
